/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Reset_Password__SubtitleInputs */

const en_auth__reset_password__subtitle = /** @type {(inputs: Auth__Reset_Password__SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're about to reset the password for your account`)
};

/**
* | output |
* | --- |
* | "You're about to reset the password for your account" |
*
* @param {Auth__Reset_Password__SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__reset_password__subtitle = /** @type {((inputs?: Auth__Reset_Password__SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Reset_Password__SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__reset_password__subtitle(inputs)
});